import { CBackdrop } from './CBackdrop.js';

const CBackdropPlugin = {
    install: (app) => {
        app.component(CBackdrop.name, CBackdrop);
    },
};

export { CBackdrop, CBackdropPlugin };
//# sourceMappingURL=index.js.map
